import { render, staticRenderFns } from "./childrenPolicyPublicityDialog.vue?vue&type=template&id=b3dc0fa2&scoped=true&"
import script from "./childrenPolicyPublicityDialog.vue?vue&type=script&lang=js&"
export * from "./childrenPolicyPublicityDialog.vue?vue&type=script&lang=js&"
import style0 from "./childrenPolicyPublicityDialog.vue?vue&type=style&index=0&id=b3dc0fa2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3dc0fa2",
  null
  
)

export default component.exports